import { Component, Inject } from '@angular/core';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FormControl, Validators } from '@angular/forms';
import { finalize, ReplaySubject, takeUntil, throwError } from 'rxjs';
import { AuthService } from 'core/services/auth.service';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { catchError } from 'rxjs/operators';
import { UsersService } from 'core';
import { KorviuInputComponent } from 'shared/components/korviu-input/korviu-input.component';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';
import { KorviuLoaderComponent } from 'shared/components/korviu-loader/korviu-loader.component';

@Component({
  selector: 'app-update-email-modal',
  standalone: true,
  imports: [
    NzIconModule,
    TranslateModule,
    NzModalModule,
    KorviuInputComponent,
    KorviuButtonComponent,
    KorviuLoaderComponent
  ],
  templateUrl: './update-email-modal.component.html',
  styleUrl: './update-email-modal.component.scss'
})
export class UpdateEmailModalComponent {
  public passwordControl: FormControl;
  public isLoading: boolean;
  public isPasswordCorrect: boolean;

  private readonly _onDestroy$: ReplaySubject<void>;

  constructor(
    @Inject(NZ_MODAL_DATA) public modalData: any,
    private _authService: AuthService,
    private _modal: NzModalRef,
    private _usersService: UsersService
  ) {
    this.isLoading = false;
    this.passwordControl = new FormControl('', [Validators.required]);
    this.isPasswordCorrect = true;
    this._onDestroy$ = new ReplaySubject<void>(1);
  }

  public ngOnInit(): void {
    this.passwordControl.valueChanges.pipe(takeUntil(this._onDestroy$)).subscribe(() => {
      this.isPasswordCorrect = true;
    });
  }

  public ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  public onUpdateClick(): void {
    this.isLoading = true;
    this._usersService
      .changePersonalInfo({ ...this.modalData, password: this.passwordControl?.value })
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
        catchError(() => {
          this.isPasswordCorrect = false;
          this.passwordControl.setErrors({ incorrect: true });
          return throwError(null);
        }),
        takeUntil(this._onDestroy$)
      )
      .subscribe(() => {
        this._modal.close(true);
      });
  }
}
